import React from 'react';
import { renderToString } from 'react-dom/server';

import { StickyNoteIcon } from '../../../icon/regular';
import {
  BaseSaveInstructionData,
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import InlineInstruction from '../base-instruction/InlineInstruction';
import { addInstructionEvent, emitInstructionEvent } from '../utils';

class NoteInstruction extends InlineInstruction {
  protected static title = 'Editor note';

  get icon() {
    return renderToString(<StickyNoteIcon style={{ height: 20 }} />);
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.NOTE_INSTRUCTION_WRAPPER,
      content: InstructionCSSClasses.NOTE_INSTRUCTION_CONTENT,
      action: InstructionCSSClasses.NOTE_INSTRUCTION_ACTION,
    };
  }

  openModal(instructionId: string): void {
    this.initEvents();
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_NOTE_INSTRUCTION_MODAL,
      { instructionId, isInline: true },
    );
  }

  getTooltip(tooltip: string): string {
    return `${InstructionActionTooltip.note}: ${tooltip}`;
  }

  initEvents() {
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_NOTE_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SET_NOTE_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  removeEvents() {
    this.api.events.off(
      InstructionEvent.SAVE_NOTE_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    this.api.events.off(
      InstructionEvent.SET_NOTE_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  saveInstruction(data: BaseSaveInstructionData) {
    if (!this.isActive) {
      this.wrap(data);
    }
    this.removeEvents();
  }

  cancel() {
    this.setSelection();
    this.removeEvents();
  }
}

export default NoteInstruction;
